export default "__VITE_ASSET__JWBN6X3y__"